import React, { useEffect } from 'react';
import framework from 'utils/framework';
import { Container } from 'components/ui';
import RelatedContent from 'components/RelatedContent';
import Location from 'utils/Location';
import anaConsts from 'analytics/constants';
import generalBindings from 'analytics/bindingMethods/pages/all/generalBindings';
import { addRelatedProductTracking } from 'utils/newBuyPage/relatedProductsTracking';
import helperUtils from 'utils/Helpers';

const { wrapFunctionalComponent } = framework;
const { deferTaskExecution } = helperUtils;

function decodeBase64(content) {
    if (!content) {
        return '';
    }

    try {
        // Same for both client and server
        // Decode the Base64 string into a binary string.
        const binaryString = atob(content);

        // Convert the binary string characters into an array of 8-bit unsigned integers.
        const bytes = Uint8Array.from(binaryString, char => char.charCodeAt(0));

        // Both client and server use TextDecoder, guaranteeing identical results.
        return new TextDecoder().decode(bytes);
    } catch (error) {
        return '';
    }
}

const NewRwdBuyPage = props => {
    const { buy } = props;
    const { content = [], linkEquityBlock } = buy;
    const decoded = decodeBase64(content);

    // Helper function to extract URL keyword from pathname
    const getUrlKeyword = () => {
        // Get location object (sanitized to remove locale prefixes)
        const location = Location.getLocation(true);
        const pathname = location.pathname || '';

        // Match pattern: /buy/[keyword]
        // Example: /buy/bright-lipstick -> captures 'bright-lipstick'
        const match = pathname.match(/^\/buy\/([^/?]+)/);

        return match ? match[1] : '';
    };

    // Analytics setup function for SEOP page load tracking
    const setPageLoadAnalytics = () => {
        const urlKeyword = getUrlKeyword();

        // Only set analytics if we have a valid keyword
        if (!urlKeyword) {
            return;
        }

        // Set page type to SEOP (SEO Pages)
        digitalData.page.category.pageType = anaConsts.PAGE_TYPES.SEOP;

        // Set page name to the URL keyword
        digitalData.page.pageInfo.pageName = urlKeyword;

        // Set world attribute (always 'n/a' for SEOP pages)
        digitalData.page.attributes.world = 'n/a';

        // Set additional page info (empty for SEOP pages)
        digitalData.page.attributes.additionalPageInfo = '';

        // Set Sephora page name using framework helper
        // This builds the format: seop:[keyword]:n/a:*
        digitalData.page.attributes.sephoraPageInfo = {
            pageName: generalBindings.getSephoraPageName()
        };
    };

    // Set PAGE LOAD analytics on component mount
    useEffect(() => {
        setPageLoadAnalytics();
    }, []);

    // Add seop tracking parameters to related product links
    useEffect(() => {
        if (decoded) {
            deferTaskExecution(() => {
                addRelatedProductTracking();
            });
        }
    }, [decoded]);

    return (
        <Container>
            <div
                dangerouslySetInnerHTML={{
                    __html: decoded
                }}
            />
            <RelatedContent
                hasDivider={content?.length > 0}
                links={linkEquityBlock?.links}
            />
        </Container>
    );
};

export default wrapFunctionalComponent(NewRwdBuyPage, 'NewRwdBuyPage');
